<template>
<!-- 直播抽奖 -->
<div class="zbcjbj">
  <el-row>
    <el-col :span="5">
      <div class="broadsidesz">
        <b>设置</b>
        <div>奖品名称　
          <el-input v-model="jpmc" size="mini" placeholder="请输入" maxlength="10"
          @blur="changeblur()" style="width: 16vh;"/>
        </div>
        <div>抽奖名额　
          <!-- <el-input v-model="cjme" size="mini" placeholder="请输入" maxlength="2" style="width: 16vh;"
          @blur="changeblur()" onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')">
            <i slot="suffix" style="line-height: 26px;margin-right: 8px;">人</i>
          </el-input> -->
          <el-select v-model="cjme" placeholder="请选择" size="mini" style="width: 16vh;">
            <el-option v-for="item in cjmeoptions" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </div>
      </div>
      
      <div class="cjjlzk" @click="toggleSidebar" v-show="isSidebarHidden">抽奖记录<i class="el-icon-arrow-right"/></div>
      <div class="broadsidecjjl" :class="{ hidden: isSidebarHidden }">
        <b>抽奖记录</b>
        <div style="height: 33vh;overflow-y: scroll;">
          <ul class="cjjlthree" v-for="(item, index) in cjjlArr" :key="index">
            <b>奖品名称：<span>{{item.prizename}}</span></b>
            <li>中奖人数：<span>{{item.winners.length}}人</span></li>
            <li>抽奖时间：<span>{{item.fist_lottery_time}}</span></li>
            <li>中奖号码：<span v-for="item in item.winners.join('、')" :key="item" style="display: inline-block;">{{item}}</span></li>
          </ul>
        </div>
        <div class="shouqiicon"><i class="el-icon-arrow-left cjjlsq" @click="toggleSidebar"/></div>
      </div>
    </el-col>
    <el-col :span="14">
    <div class="lottery-container">
    <div class="lottery-main">
      <div class="lottery-tips">
        <span v-show="!jpmc">{{maxAwardTips}}</span><span v-show="jpmc">{{jpmc}}（{{rollLen}} / {{cjme}}人）</span>
      </div>
      <ul>
        <li class="lottery-item" v-for="(item, index) in smokeArr" :key="index">
          <div class="lottery-roll">
            <div class="roll-item"><img :src="item.usericon"></div>
            <div class="roll-item"><span>{{item.phone}}</span></div>
            <div class="roll-item"><span>{{item.playercode}}</span></div>
          </div>
        </li>
      </ul>
    </div>
    <div class="lottery-btn">
      <div class="btn-func" v-show="zbcjState!=4">
        <button class="btnImg" @click="beginRoll" :disabled="prohibitrepetition"><img src="../assets/img/ks.png"/></button>
        <button class="btnImg" @click="stopRoll" :disabled="!prohibitrepetition"><img src="../assets/img/cq.png"/></button>
      </div>
    </div>
    </div>
    </el-col>
    <el-col :span="5">
    <div style="position: absolute;right: 0;">
      <div class="broadsidesz">
        <b>本轮抽奖</b>
        <template v-if="thissmoke.prizename">
          <ul style="margin: 10px 0 10px 30px;">
            <li>奖品名称：<span>{{thissmoke.prizename}}</span></li>
            <li>中奖人数：<span>{{thissmoke.winners.length}}人</span></li>
            <li>抽奖时间：<span>{{thissmoke.fist_lottery_time}}</span></li>
          </ul>
          <b>中奖号码</b>
          <ul style="margin: 10px 0 0 30px;">
            <li v-for="item in thissmoke.winners" :key="item">{{item}}</li>
          </ul>
        </template>
        <div v-else style="text-align: center;margin-bottom: 10px;"><b>暂无数据</b></div>
      </div>
    </div>
    </el-col>
  </el-row>
</div>
</template>
<script>
import { getplayer, getwinners, postlottery } from "../api/shopWindow";
export default {
  name: 'livelottery', // 直播抽奖
  data() {
    return {
      jpmc: '',
      cjme: 1,
      cjmeoptions: [{
        value: 1,
        label: '1'
      }, {
        value: 2,
        label: '2'
      }, {
        value: 3,
        label: '3'
      }, {
        value: 4,
        label: '4'
      }, {
        value: 5,
        label: '5'
      }],
      isSidebarHidden: true, // 侧边抽奖记录
      cjjlArr: [], // 抽奖记录集合
      thissmoke: {}, // 本轮抽奖
      
      maxAwardTips: '请输入奖品名称和抽奖名额', // 请输入奖品名称和抽奖名额
      rollLen: 0, // 本轮已抽中用户数
      
      // 闪烁集合
      flickerArr: [
        {
          "userid": 15092,
          "phone": "138****0739",
          "playercode": "434949",
          "usericon": require('../assets/img/bicon37.png')
        },
        {
          "userid": 15097,
          "phone": "151****6933",
          "playercode": "492695",
          "usericon": require('../assets/img/bicon37.png')
        },
        {
          "userid": 15096,
          "phone": "156****9125",
          "playercode": "390250",
          "usericon": require('../assets/img/bicon37.png')
        },
        {
          "userid": 15095,
          "phone": "151****5602",
          "playercode": "017845",
          "usericon": require('../assets/img/bicon37.png')
        },
        {
          "userid": 15092,
          "phone": "138****0739",
          "playercode": "842859",
          "usericon": require('../assets/img/bicon37.png')
        }
      ],
      smokeArr: [], // 抽中集合
      listId: '', // 幸运购id
      zjArr: '', // 中奖集合
      extract: '', // 已抽取数量
      timer: '', // 定时器
      prohibitrepetition: false, // 禁止重复点击
      zbcjState: '', // 处理已结束状态 4
    }
  },
  methods: {
    toggleSidebar() {
      this.isSidebarHidden = !this.isSidebarHidden;
    },
    // 抽奖集合
    getchoujiang(){
      getplayer('',1,this.listId).then(data => {
        if (data.resultCode == 1) {
          this.smokeArr = data.resultObj; // 先赋值大列表
          this.flickerArr = this.smokeArr; // 闪动数据赋值
        } else {
          this.smokeArr = [];
        }
      });
    },
    changeblur(){
      this.rollLen = 0;
    },
    // 开始
    beginRoll(){
      this.thissmoke = {
        prizename: '', // 奖品名称
      }
      if (this.jpmc == "") {
        this.$swal({
          text: "请输入奖品名称",
          type: "warning"
        });
        return false;
      }
      // if(this.cjme == ''){
      //   this.$swal({
      //     text: "请输入抽奖名额",
      //     type: "warning"
      //   });
      //   return false;
      // }
      if(this.cjme == this.rollLen){
        this.$confirm('当前奖品已完成抽奖，是否再次抽取一轮该奖品？', '温馨提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.prohibitrepetition = true;
          this.rollLen = 0;
          this.smokeArr=[];
          this.getzhongjiang(); // 中奖集合
          // this.$message({
          //   type: 'success',
          //   message: '操作成功!'
          // });
        }).catch(() => {
          this.prohibitrepetition = false;
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      }else{
        this.prohibitrepetition = true;
        this.rollLen = 0;
        this.smokeArr=[];
        this.getzhongjiang(); // 中奖集合
      }
    },
    // 中奖集合
    getzhongjiang(){
      let obj = {
        operatorid: localStorage.Id, // 操作人id
        lotterytype: 1, // 抽奖类型 1=幸运购抽奖 不传则默认1
        businessid: this.listId, // 业务主键ID，与抽奖类型配合使用 (如类型为幸运购抽奖，此字段为幸运购的活动ID)
        prizename: this.jpmc, // 奖品名称
        prizenum: Number(this.cjme), // 奖品总数
        count: 5, // 本轮最大中奖人数 不传则默认5
        isfilterwinner: 0, // 是否过滤中奖者0=否 1=是 不传则默认0
        remark: '', // 奖品备注 不传则默认空
      }
      postlottery(obj).then(data => {
        if (data.resultCode == 1) {
          this.zjArr = data.resultObj.winners; // 中奖集合
          this.extract = data.resultObj.prewinnernum; // 当前奖品已抽取数量
          this.smokeArr.length = this.cjme>5?5:this.cjme; // 赋值条数
          this.timer = setInterval(()=>{
            let n = Math.floor(Math.random() * (this.flickerArr.length - this.cjme))
            let m = n+Number(this.cjme)
            this.smokeArr = this.flickerArr.slice(n, m);
          }, 100)
        } else {
          // this.smokeArr = [];
          this.rollLen = 0;
          this.getchoujiang(); // 抽奖集合
          this.$swal({
            text: data.resultMsg,
            type: 'warning'
          })
        }
      });
    },
    // 抽取
    stopRoll(){
      clearInterval(this.timer);
      this.prohibitrepetition = false;
      // this.jpmc='';
      // this.cjme=1;
      this.smokeArr = this.zjArr;
      this.rollLen = this.extract;
      this.getcjjl(2); // 抽奖记录
    },
    // 抽奖记录
    getcjjl(type){
      getwinners('',1,this.listId).then(data => {
        if (data.resultCode == 1) {
          this.cjjlArr = data.resultObj;
          if(type==2){
            this.thissmoke = this.cjjlArr[this.cjjlArr.length-1]; // 赋值本轮抽奖
          }
        } else {
          this.cjjlArr = [];
        }
      });
    },
    
  },
  created() {
    this.listId = this.$route.query.yyqid; // 获取幸运购id
    this.zbcjState = this.$route.query.zbcjState; // 获取选中行状态 4
    this.getcjjl(1); // 抽奖记录
    this.getchoujiang(); // 抽奖集合
  },
  mounted(){
    
  },
}
</script>
<style>
/* 抽奖背景 */
.zbcjbj{
  width: 100%;
  height: 100vh;
  background: url('../assets/img/zbcj.png') no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
}
/* 设置 */
.broadsidesz{
  width: 30vh;
  height: 161px;
  background: #CE333A;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin-top: 200px;
  margin-bottom: 20px;
  padding-top: 30px;
  color: #fff;
}
.broadsidesz>b{
  font-size: 20px;
  color: #EECC44;
  margin-left: 30px;
}
.broadsidesz>div{
  margin-left: 30px;
  padding-top: 20px;
}
/* 抽奖记录 */
.broadsidecjjl{
  width: 30vh;
  height: auto;
  background: #CE333A;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  padding: 30px 0;
  color: #fff;
}
.broadsidecjjl.hidden {
  transform: translateX(-30vh);
}
.broadsidecjjl>b{
  font-size: 20px;
  color: #EECC44;
  margin-left: 30px;
}
.cjjlthree{
  margin: 20px 0 0 30px;
}
/* 收起箭头 */
.shouqiicon{
  width: 100%;
  height: 20px;
  margin-top: 10px;
  position: relative;
}
.cjjlsq{
  width: 32px;
  height: 32px;
  line-height: 32px;
  background: #EECC44;
  border-radius: 50px;
  text-align: center;
  color: #222222;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  right: 30px;
  cursor: pointer;
}
.cjjlzk{
  width: 150px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #EECC44;
  border-radius: 0px 25px 25px 0px;
  opacity: 1;
  font-size: 20px;
  font-weight: bold;
  color: #222222;
  cursor: pointer;
}
.cjjlzk>i{
  font-weight: bold;
}

.lottery-container{
  width: 80%;
  height: 100vh;
  position: relative;
}
.lottery-main{
  width: 100%;
  height: 48vh;
  position: absolute;
  left: 10%;
  top: 26%;
  /* transform: translate3d(-50%,0,0); */
  z-index: 2;
  overflow: hidden;
}
.lottery-tips{
  font-size: 3vh;
  font-weight: bold;
  color: #fff;
  text-align: center;
}
.lottery-item{
  height: 7.6vh;
  line-height: 7.6vh;
  margin-top: 1%;
  text-align: center;
  background-image: url(../assets/img/roll.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;
}
.lottery-roll{
  display: flex;
}
.roll-item{
  width: 35%;
  /* font-size: 3.6vh; */
  font-size: 36px;
  font-weight: bold;
  color: #222222;
  display: flex;
  justify-content: center;
  align-items: center;
}
.roll-item:first-child{
  width: 20%;
}
.roll-item:last-child{
  width: 50%;
}
.roll-item>span{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.roll-item>img{
  width: 5vh;
  height: 5vh;
  border-radius: 50%;
}
.lottery-btn{
  position: absolute;
  width: 80%;
  left: 62%;
  bottom: 13%;
  transform: translate3d(-50%, 0, 0);
  z-index: 2;
}
.btn-func{
  padding: 0 15%;
  display: flex;
  justify-content: space-between;
}
.btnImg{
  width: 186px;
  height: 86px;
  border-radius: 30vh;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}
.btnImg>img{
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// livelottery.vue?3a558d48